export const CONTACT_US_EMAIL = 'contact-marketplace@inato.com';
